import { TOKEN, REFRESH_TOKEN } from 'commons/constants/store'
import { User, UserPermission, UserProfile } from 'commons/types/user'
import { AuthResponse } from 'services/models/auth'
import storage from '../storage'
import { setGtagUser } from '../user'
import * as jwt from './jwt'

const state = {
  accessToken: '',
  refreshToken: '',
  token: {
    exp: 0,
    expAC: 0,
  },
  user: {
    id: 0,
    name: '',
    email: '',
    permissions: [],
    profiles: ['GESTOR'],
    authenticated: false,
  } as User,
}

/** GETTERS */

function isTokenExpired(exp: number | string | null | undefined) {
  return !exp || new Date().getTime() > Number(exp) * 1000
}

function hasValidToken() {
  return state.accessToken && state.token.exp && new Date().getTime() < state.token.exp * 1000
}

/** METHODS */

function handleAccessToken(token: string, refreshToken?: string): User {
  const parsedToken = jwt.decode(token)

  const user: User = {
    id: Number(parsedToken?.userId),
    name: parsedToken?.name || '',
    email: parsedToken?.email || '',
    profiles: (parsedToken?.profiles || '').split(',').map(profile => profile as UserProfile),
    permissions: (parsedToken?.roles || '').split(',').map(profile => profile as UserPermission),
    authenticated: Boolean(parsedToken?.email),
  }

  state.user = user
  state.accessToken = token
  state.token.exp = parsedToken?.exp || 0
  state.token.expAC = parsedToken?.expAC || 0

  setGtagUser(user.id)

  storage.add(TOKEN, token)

  if (refreshToken) {
    state.refreshToken = refreshToken
    storage.add(REFRESH_TOKEN, refreshToken)
  }

  return user
}

function getInitialUser(tokens?: AuthResponse) {
  const token = tokens?.token || storage.take(TOKEN)
  const refreshToken = tokens?.refreshToken || storage.take(REFRESH_TOKEN)

  return handleAccessToken(token, refreshToken)
}

export { state as user, isTokenExpired, hasValidToken, handleAccessToken, getInitialUser }
